<p-panel class="panel-padding mt-4" [toggleable]="false" [header]="physicianCombineData.accountName">
  <div class="grid grid-cols-12 gap-4 p-fluid p-form-widget p-form-view-data">
    <div class="col-span-12 md:col-span-4">
      <div class="field">
        <p class="font-semibold">General Information</p>
      </div>
      <div class="field">
        <label>NPI: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.practiceNpinumber }}</div>
        </div>
      </div>
      @if (!isExternalUser) {
        <div class="field">
          <label>Portal Provider ID: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{ physicianCombineData.accountId }}</div>
          </div>
        </div>
      }
      <div class="field">
        <label>Tax ID: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.practiceTaxId }}</div>
        </div>
      </div>
      @if (!isExternalUser) {
        <div class="field">
          <label>Provider Type: </label>
          <div class="p-field-value">
            <div class="readonly-field">{{ physicianCombineData.providerType }}</div>
          </div>
        </div>
      }
    </div>

    <div class="col-span-12 md:col-span-4">
      <div class="field">
        <p class="font-semibold">Location Information</p>
      </div>
      <div class="field">
        <label>Street: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.physicalStreet }}</div>
        </div>
      </div>
      <div class="field">
        <label>City: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.physicalCity }}</div>
        </div>
      </div>
      <div class="field">
        <label>State: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.physicalState }}</div>
        </div>
      </div>
      <div class="field">
        <label>ZIP Code: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.physicalZip }}</div>
        </div>
      </div>
    </div>

    <div class="col-span-12 md:col-span-4">
      <div class="field">
        <p class="font-semibold" data-test-id="location-info">Authorization Information</p>
      </div>
      <div class="field">
        <label>Phone: </label>
        <div class="p-field-value">
          <div class="readonly-field">{{ physicianCombineData.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</p-panel>
